/**
 * @generated SignedSource<<4d8a06696844cad2c847d44d0ea074c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteUserInput = {
  userId: string;
};
export type User_deleteUser_Mutation$variables = {
  input: DeleteUserInput;
};
export type User_deleteUser_Mutation$data = {
  readonly deleteUser: {
    readonly user: {
      readonly id: string;
    };
  } | null;
};
export type User_deleteUser_Mutation = {
  response: User_deleteUser_Mutation$data;
  variables: User_deleteUser_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteUserPayload",
    "kind": "LinkedField",
    "name": "deleteUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "User_deleteUser_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "User_deleteUser_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ac3f1b3608938b9ea65c35cadba40e0",
    "id": null,
    "metadata": {},
    "name": "User_deleteUser_Mutation",
    "operationKind": "mutation",
    "text": "mutation User_deleteUser_Mutation(\n  $input: DeleteUserInput!\n) {\n  deleteUser(input: $input) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eedf29b62d3539ec3a2771c71cf6e4dc";

export default node;
